import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="update-delivery-group-representative"
export default class extends Controller {
  connect() {
    console.log("updateDeliveryGroupRepresentativeController connected");
  }

  update(event) {
    const id = event.target.closest("tr").dataset.deliveryGroupId;
    const representative_name = event.target.value;
    const status = null;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    fetch(`/delivery_groups/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ delivery_group: { representative_name, status } })
    });
  }
}
